import React from 'react';
import PropTypes from 'prop-types';
import {
  numberUI,
  numberSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { isRelationshipToVeteran } from '../../../utils/helpers';
import content from '../../../utils/content.json';

const Description = ({ formData }) => (
  <div>
    {isRelationshipToVeteran(formData) === 'spouse' && (
      <p>
        Next we’ll ask you for information about the Veteran’s dependent
        children. You’ll need to give information for all the Veteran’s
        children, even if they were not from your marriage together.
      </p>
    )}
    {isRelationshipToVeteran(formData) === 'custodian' && (
      <p>
        Next we’ll ask you for information about the Veteran’s dependent
        children. You’ll need to give information for all the Veteran’s
        children, including the children that aren’t in your custody.
      </p>
    )}
    {isRelationshipToVeteran(formData) === 'child' && (
      <p>
        Next we’ll ask you for information about the Veteran’s dependent
        children. You’ll need to give information for all the Veteran’s
        children, including yourself.
      </p>
    )}
    <p>
      A dependent child is an unmarried child (including an adopted child or
      stepchild) who meets 1 of the eligibility requirements:
    </p>
    <ul>
      <li>They’re under 18 years old, or</li>
      <li>
        They’re between the ages of 18 and 23 years old and enrolled in school
        full time, or
      </li>
      <li>They became permanently disabled before they turned 18</li>
    </ul>
  </div>
);

Description.propTypes = {
  formData: PropTypes.object,
};

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI({
      title: content['household-dependents-count-title'],
      description: ({ formData }) => <Description formData={formData} />,
    }),
    veteranChildrenCount: {
      ...numberUI({
        title: content['household-dependents-count-number'],
        hint: content['household-dependents-count-number-hint'],
        errorMessages: {
          pattern: content['number-error'],
        },
        min: 0,
        max: 99,
      }),
    },
    'view:dependentChildInfo': {
      'ui:description': (
        <va-additional-info trigger="If there are more than 3 dependents">
          <p>
            You can add information for up to 3 dependents in the next section.
            Additional children can be added using an Application Request to Add
            and/or Remove Dependents (VA Form 21-686c).
          </p>
          <p>
            You can submit this form online, upload it at the end of this
            application, or send it to us by mail.
          </p>
          <span className="vads-u-display--block vads-u-margin-bottom--2">
            <va-link
              href="https://www.va.gov/manage-dependents/add-remove-form-21-686c-674"
              external
              text="Add or remove dependents on VA benefits"
            />
          </span>
          <span className="vads-u-display--block">
            <va-link
              href="https://www.va.gov/find-forms/about-form-21-686c/"
              external
              text="Get VA Form 21-686c to download"
            />
          </span>
        </va-additional-info>
      ),
      'ui:options': {
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['veteranChildrenCount'],
    properties: {
      veteranChildrenCount: numberSchema,
      'view:dependentChildInfo': {
        type: 'object',
        properties: {},
      },
    },
  },
};
